// import { UpdateCard } from "../components/update-card/update-card";
import { UpdateCard } from "./interfaces/UpdateCardInterface"

export const UPDATES: Array<UpdateCard> = [
    {
        imgLink: 'assets/update-card-1.jpg',
        title: 'Titulo caja ancha',
        subtitle: 'Subtitulo caja ancha',
        text: 'Contenido caja ancha Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero dicta minus quo, impedit similique explicabo autem blanditiis aspernatur doloribus eius odio minima ex distinctio labore laboriosam expedita sequi culpa. Saepe!',
        link: '#',
        
    },
    {
        imgLink: 'assets/update-card-1.jpg',
        title: 'Titulo peque',
        subtitle: 'Subtitulo peque',
        text: 'Contenido Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero dicta minus quo, impedit similique explicabo autem blanditiis aspernatur doloribus eius odio minima ex distinctio labore laboriosam expedita sequi culpa. Saepe!',
        // link: '#',
        
    },
    {
        imgLink: 'assets/update-card-1.jpg',
        title: 'Titulo este es diferente',
        subtitle: 'Subtitulo',
        text: 'Contenido Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero dicta minus quo, impedit similique explicabo autem blanditiis aspernatur doloribus eius odio minima ex distinctio labore laboriosam expedita sequi culpa. Saepe!',
        link: '#',
        
    },
    {
        imgLink: 'assets/update-card-1.jpg',
        title: 'Titulo y este tamb',
        subtitle: 'Subtitulo',
        text: 'Contenido Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero dicta minus quo, impedit similique explicabo autem blanditiis aspernatur doloribus eius odio minima ex distinctio labore laboriosam expedita sequi culpa. Saepe!',
        // link: '#',
        
    },

]

